"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSchema = void 0;
var _culture = require("@ori/culture");
var _zod = require("zod");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../../hooks/useTranslations_simplified-registration-BrandPartner");
var _models = require("../../../models");
var _utils = require("../../../utils");
const useGetSchema = (isParentalRequired, config, contactTelephone, contactEmail) => {
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const {
    culture
  } = (0, _culture.useCulture)();
  const culturePattern = culture?.calendarFormat?.patterns?.shortDatePattern;
  if (!config) {
    return _zod.z.object({});
  }
  const {
    confirmation1,
    confirmation2,
    parentalConsent,
    termsAndConditions,
    identityCard,
    additionalIdentityCard
  } = config;
  let schema = _zod.z.object({});
  schema = _zod.z.object({
    isReseller: _zod.z.boolean().optional(),
    confirmation1: (0, _utils.createFieldSchema)(formatMessage, confirmation1, 'boolean'),
    confirmation2: (0, _utils.createFieldSchema)(formatMessage, confirmation2, 'boolean'),
    approvals: _zod.z.object({
      personalData: _zod.z.boolean().optional(),
      contact: _zod.z.boolean().optional(),
      marketingOriflame: _zod.z.boolean().optional(),
      marketingExternal: _zod.z.boolean().optional(),
      publication: _zod.z.boolean().optional(),
      newsletters: _zod.z.boolean().optional(),
      uplineLeaderData: _zod.z.boolean().optional(),
      uplineLeaderBrowse: _zod.z.boolean().optional(),
      orderHistory: _zod.z.boolean().optional(),
      marketingConsultant: _zod.z.boolean().optional(),
      blockGuaranteeOrdering: _zod.z.boolean().optional(),
      optedOutOfSponsorSelect: _zod.z.boolean().optional()
    }).nullish(),
    termsAndConditions: _zod.z.object({
      termId: (0, _utils.createFieldSchema)(formatMessage, termsAndConditions, 'string')
    }).nullish(),
    parentalConsent: _zod.z.object({
      telephone: (0, _utils.createFieldSchema)(formatMessage, {
        ...parentalConsent?.telephone,
        validation: {
          ...parentalConsent?.telephone?.validation,
          isMandatory: parentalConsent?.telephone?.validation?.isMandatory && isParentalRequired
        }
      }, 'string', undefined, 'phone'),
      email: (0, _utils.createFieldSchema)(formatMessage, {
        ...parentalConsent?.email,
        validation: {
          ...parentalConsent?.email?.validation,
          isMandatory: parentalConsent?.email?.validation?.isMandatory && isParentalRequired
        }
      }, 'string', undefined, 'email')
    }).superRefine((data, ctx) => {
      if (data.telephone && data.telephone === contactTelephone) {
        ctx.addIssue({
          code: _zod.z.ZodIssueCode.custom,
          message: formatMessage(_models.TranslationKey.ParentalConsentSamePhoneValidation),
          path: ['telephone']
        });
      }
      if (data.email && data.email === contactEmail) {
        ctx.addIssue({
          code: _zod.z.ZodIssueCode.custom,
          message: formatMessage(_models.TranslationKey.ParentalConsentSameEmailValidation),
          path: ['email']
        });
      }
    }).nullish(),
    additionalIdentityCard: additionalIdentityCard?.validation?.isMandatory ? _zod.z.object({
      documentsCollection: _zod.z.array(_zod.z.object({
        documentId: _zod.z.number().int().positive()
      })).nonempty()
    }) : _zod.z.object({
      documentsCollection: _zod.z.array(_zod.z.object({
        documentId: _zod.z.number().int().positive()
      })).nullish()
    }).nullish(),
    identityCard: identityCard?.validation?.isMandatory && !identityCard?.expiration?.validation?.isMandatory ? _zod.z.object({
      documentsCollection: _zod.z.array(_zod.z.object({
        documentId: _zod.z.number().int().positive()
      })).nonempty(),
      expiration: (0, _utils.createFieldSchema)(formatMessage, identityCard.expiration, 'date', culturePattern),
      cardType: (0, _utils.createFieldSchema)(formatMessage, identityCard.cardType, 'string'),
      cardNumber: (0, _utils.createFieldSchema)(formatMessage, identityCard.cardNumber, 'string')
    }) : identityCard?.expiration?.validation?.isMandatory ? _zod.z.object({
      documentsCollection: _zod.z.array(_zod.z.object({
        documentId: _zod.z.number().int().positive()
      })).nonempty(),
      expiration: (0, _utils.createFieldSchema)(formatMessage, identityCard.expiration, 'date', culturePattern).nullish(),
      cardType: (0, _utils.createFieldSchema)(formatMessage, identityCard.cardType, 'string'),
      cardNumber: (0, _utils.createFieldSchema)(formatMessage, identityCard.cardNumber, 'string')
    }).refine(data => {
      const disabledTypes = identityCard?.expiration?.disabledForIdentityCardTypes ?? [];
      return identityCard.expiration?.validation?.isMandatory ? disabledTypes.includes(data.cardType) || data.expiration !== null : false;
    }, {
      message: formatMessage(_models.TranslationKey.validationRequired),
      path: ['expiration']
    }) : _zod.z.object({
      documentsCollection: _zod.z.array(_zod.z.object({
        documentId: _zod.z.number().int().positive()
      })).nullish()
    }).nullish()
  });
  return schema;
};
exports.useGetSchema = useGetSchema;